import { render, staticRenderFns } from "./softWareDetail.vue?vue&type=template&id=5eb4f7cf&scoped=true"
import script from "./softWareDetail.vue?vue&type=script&lang=js"
export * from "./softWareDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb4f7cf",
  null
  
)

export default component.exports